import React from 'react'
import { 
  Grid, GridRow, GridColumn, Header, HeaderContent, Dropdown, Popup, 
  Icon, 
  Input
} from 'semantic-ui-react'

import CreateUserModal from '../../components/useradmin/createUserModal'


function HeaderForm(
  {usersLoaded, onChangeSearchText, pagesize, updatePageSize, refresh, filtered_users_count, totalcount, 
    onCreateUser, formConfigData, searchMatches
  }) {
  
  const [showCreateModal, toggleCreateModal] = React.useState(false)
  const [text, setText] = React.useState("")

  /* PageSize */
  const pageSizeOptions = () => { 
    return [{ key: '20', value: '20', text: '20' },
    { key: '50', value: '50', text: '50' },
    { key: '100', value: '100', text: '100' }]
  }
  const onChangePagesize = (pagesize) => { updatePageSize(parseInt(pagesize)) }


  return (
    <>
        <Grid container>
          <Grid.Row centered verticalAlign='middle' textAlign='center'>
            <h2>Användaradministration</h2>
          </Grid.Row>


          <Grid.Row verticalAlign="middle" >
            <Grid.Column width={2}></Grid.Column>
            
            <Grid.Column width={2}>
              <Popup content='Antal användare att presentera' trigger={
                <Dropdown
                  onChange={(e, data) => { onChangePagesize(data.value) }}
                  simple item selection compact
                  options={pageSizeOptions()}
                  text={pagesize.toString()}
                />
              }/>
            </Grid.Column>

            <Grid.Column width={8}>
              <Popup content='Sök på telefonnummer, namn, avdelning osv..' trigger={
                <Input
                  onChange={(e, data) => { onChangeSearchText(data.value) }}
                  placeholder="sök.."
                  icon='search'
                  fluid
                />
              }/>
            </Grid.Column>

            <Grid.Column width={3} >
            {
                usersLoaded 
                && <Popup 
                      content='Ladda om användare' 
                      trigger={
                                <Icon link 
                                      name='redo' 
                                      size='large' 
                                      onClick={() => {refresh()}} 
                                />
                              } 
                  />
                || <Icon link disabled name='redo' size='large' />
              }



                {/* <Popup 
                      content='Skapa ny användare' 
                      trigger={
                                <Icon link 
                                      name='add' 
                                      size='large' 
                                      onClick={() => { toggleCreateModal(true) }} 
                                />
                              }
                  /> */}

            </Grid.Column>
            <Grid.Column width={1}></Grid.Column>

        </Grid.Row>



        <Grid.Column width={16} centered="true" verticalAlign='top'>
          {
            searchMatches && searchMatches > 0 && <p>Visar {filtered_users_count()} av {searchMatches} sökresultat</p>
            ||
            <p>Visar {filtered_users_count()} av {totalcount()} användare.</p>
          }
        </Grid.Column>

        </Grid>
        {/* {
          showCreateModal &&
            <CreateUserModal
              user={{}}
              toggleModal={toggleCreateModal}
              show={showCreateModal}
              onSubmit={onCreateUser}
              configData={formConfigData}
            />
        } */}
    </>
  )
}

export default HeaderForm
